import axios from "axios";

// const API_URL =
//   window.location.hostname === "localhost"
//     ? "http://localhost:3000"
//     : "https://uy9nfxntoh.execute-api.us-west-2.amazonaws.com/PilotMode";

const API_URL ="https://97ny4m4be2.execute-api.ap-south-1.amazonaws.com/LiveMode";
// const API_URL ="http://localhost:3000";
// googleId
// 393877425666-o8ddqc94htm7q047r1m8j06n3v62v2m3.apps.googleusercontent.com

// {
//  "mapId": "googleId",
//  "mapValue": "393877425666-o8ddqc94htm7q047r1m8j06n3v62v2m3.apps.googleusercontent.com"
// }
const getAuthToken = () => localStorage.getItem('authToken');

const isTokenExpiredResponse = (status, data) => {
  if (status !== 401) return false;
  const errorCode = (data?.error || "").toString().toLowerCase();
  const message = (data?.message || "").toString().toLowerCase();
  return errorCode === "token_expired" || message.includes("token expired");
};

const notifySessionExpired = (message = "Session expired. Please login again.") => {
  window.dispatchEvent(
    new CustomEvent("session-expired", {
      detail: { message },
    })
  );
};

const handleAxiosAuthError = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data;

  if (isTokenExpiredResponse(status, data)) {
    notifySessionExpired(data?.message || "Session expired. Please login again.");
  }
};

const authFetch = async (url, options = {}) => {
  const response = await fetch(url, options);

  if (response.status === 401) {
    let data = {};
    try {
      data = await response.clone().json();
    } catch (e) {
      data = {};
    }

    if (isTokenExpiredResponse(response.status, data)) {
      notifySessionExpired(data?.message || "Session expired. Please login again.");
    }
  }

  return response;
};


/**
 * Add a new user/employee
 * @param {Object} userData - User data to submit
 * @returns {Promise<Object>} API response
 */
export const addUser = async (userData) => {
  try {
    const response = await authFetch(`${API_URL}/manage-office/add/user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getAuthToken()}`,
      },
      body: JSON.stringify(userData),
    });

    // Get response details for better error handling
    const responseText = await response.text();
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch (e) {
      responseData = { message: responseText };
    }

    if (!response.ok) {
      throw new Error(
        `API Error (${response.status}): ${
          responseData.message || responseText || "Unknown error"
        }`
      );
    }

    return responseData;
  } catch (error) {
    console.error("Error adding user:", error);
    throw error;
  }
};

// User Login API
export const userLogin = async (requestPayload) => {
  try {
    const response = await axios.post(
      `${API_URL}/user-auth/login/1`,
      requestPayload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.log("Login error:", error);
    return error;
  }
};

// Google SSO Login API
export const googleSsoLogin = async (token, phoneNumber = null) => {
  try {
    const payload = { token };

    // Include phoneNumber only when available (for new-user flows)
    if (phoneNumber) {
      payload.phoneNumber = phoneNumber;
    }

    const response = await axios.post(
      `${API_URL}/user-auth/OAuth2Client/login`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.log("Google login error:", error);
    return error;
  }
};

// Get User Tasks API
export const getUsersAPI = async () => {
  // Trim the userId to remove any accidental spaces
  try {
    const response = await axios.get(
      `${API_URL}/user-auth/userinfo/1`,
      {
        headers: {
          "Authorization": `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    handleAxiosAuthError(error);
    console.log("Error in getTasksAPI:", error);
    throw error;
  }
};


// User Login API
export const createUser = async (requestPayload) => {
  try {
    const response = await axios.patch(
      `${API_URL}/user-auth/login/1`,
      requestPayload,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    handleAxiosAuthError(error);
    console.log("Login error:", error);
    return error;
  }
};

// Edit Users 
export const editUser = async (requestPayload) => {
  try {
    const response = await axios.patch(
      `${API_URL}/user-auth/update/UserPermission`,
      requestPayload,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    handleAxiosAuthError(error);
    console.log("Login error:", error);
    return error;
  }
};


// Change Password API
export const changePassword = async (userData) => {
  try {
    console.log('Making password change request:', userData);
    
    const response = await authFetch(`${API_URL}/user-auth/change-password/2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getAuthToken()}`,
      },
      body: JSON.stringify(userData),
    });

    console.log('Raw response:', response);
    const data = await response.json();
    console.log('Parsed response:', data);

    return data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

// userStatusAction
// Change Password API
export const userStatusAction = async (userData) => {
  try {
    console.log('Making user status change request:', userData);

    const response = await authFetch(`${API_URL}/user-auth/user-action/4`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getAuthToken()}`,
      },
      body: JSON.stringify(userData),
    });

    console.log('Raw response:', response);
    const data = await response.json();
    console.log('Parsed response:', data);

    return data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};


/**
 * Get countries from the API
 * @returns {Promise<Array>} Array of countries
 */
export const getCountries = async () => {
  try {
    const response = await authFetch(`${API_URL}/manage-office/country`, {
      headers: {
        "Authorization": `Bearer ${getAuthToken()}`,
      },
    });
    const result = await response.json();
    if (result.status && result.data) {
      return result.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching countries:", error);
    throw error;
  }
};

// Leads API endpoints
export const getLeads = async () => {
  try {
    const response = await authFetch(`${API_URL}/manage-leads/getLead`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching leads:', error);
    throw error;
  }
};

export const getNewLeadData = async (month) => {
  try {
    const clientId = "4739207";
    if (!clientId) {
      throw new Error('Client ID not found in localStorage');
    }
    if (!month) {
      throw new Error('Month parameter is required');
    }

    const url = `${API_URL}/manage-leads/getNewLead?month=${encodeURIComponent(month)}&&clientId=${encodeURIComponent(clientId)}`;
    const response = await authFetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching new lead data:', error);
    throw error;
  }
};

// Get Qualified Leads
export const getQualifiedLeadData = async (month) => {
  try {
    const clientId = getClientId();
    if (!clientId) throw new Error('Client ID not found');
    if (!month) throw new Error('Month parameter is required');
    const url = `${API_URL}/manage-leads/Qualified?month=${encodeURIComponent(month)}&&clientId=${encodeURIComponent(clientId)}`;
    const response = await authFetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getAuthToken()}` } });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error fetching qualified lead data:', error);
    throw error;
  }
};

// Orucore Client ID - Very important
const getClientId = () =>  '4739207';

// Get Other Leads
export const getOtherLeadData = async (month) => {
  try {
    const clientId = getClientId();
    if (!clientId) throw new Error('Client ID not found');
    if (!month) throw new Error('Month parameter is required');
    const url = `${API_URL}/manage-leads/getOtherLeads?month=${encodeURIComponent(month)}&&clientId=${encodeURIComponent(clientId)}`;
    const response = await authFetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getAuthToken()}` } });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error fetching other lead data:', error);
    throw error;
  }
};

// Create new lead
export const newLead = async (leadData, routeSegment = 'r1') => {
  try {
    const response = await authFetch(`${API_URL}/manage-leads/${routeSegment}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`,
      },
      body: JSON.stringify({
        ...leadData,
        clientId: '4739207',
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to create lead');
    }

    return data;
  } catch (error) {
    console.error('Error creating lead:', error);
    throw error;
  }
};

// Bulk-create leads by uploading a CSV file. The backend is expected to
// extract the rows from the file and insert them into DynamoDB.
export const bulkUploadLeads = async (file, routeSegment = 'bulkUpload') => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileType', 'csv');
    formData.append('clientId', '4739207');

    const response = await authFetch(`${API_URL}/manage-leads/${routeSegment}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`,
      },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to bulk upload leads');
    }

    return data;
  } catch (error) {
    console.error('Error bulk uploading leads:', error);
    throw error;
  }
};

export const updateLead = async (leadData, routeSegment = 'r1') => {
  try {
    const response = await authFetch(`${API_URL}/manage-leads/${routeSegment}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`,
      },
      body: JSON.stringify({
        ...leadData,
        clientId: '4739207',
      }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to update lead');
    }

    return data;
  } catch (error) {
    console.error('Error updating lead:', error);
    throw error;
  }
};

// Add a follow-up comment to a lead
// Comments history comes back on the lead object itself (lead.comments) from
// getNewLeadData/getQualifiedLeadData/getOtherLeadData, so no separate GET is needed.
export const addLeadComment = async (lead, comment, routeSegment = 'comments') => {
  try {
    const response = await authFetch(`${API_URL}/manage-leads/${routeSegment}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`,
      },
      body: JSON.stringify({
        leadId: lead.leadId,
        comment,
        clientId: '4739207',
        createdDate: lead.createdDate,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to add follow-up comment');
    }

    return data;
  } catch (error) {
    console.error('Error adding lead comment:', error);
    throw error;
  }
};

// Add this function to your API utilities
export const verifyUserId = async (userId) => {
  try {
    const response = await authFetch(
      `${API_URL}/user-auth/verify-userId/3`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getAuthToken()}`,
        },
        body: JSON.stringify({ userId }),
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error verifying userId:", error);
    throw error;
  }
};

